import React, { Component } from "react";
import { Link } from "react-router-dom";

//import { connect } from "react-redux";

class HeaderNav extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="container">
          <div className="text-center">
            <a className="social d-block mb20" href="https://www.facebook.com/cinevauban/">
              <span className="d-block mb10">
                <i className="fab fa-facebook-square"></i>
              </span>
              <span>nous suivre</span>
            </a>
            <span className="copy d-block mb10">
              <Link to="/MentionsLegales">Mentions Légales</Link>
              {" | "}
              <Link to="/Confidentialite">Politique de confidentialité</Link>
            </span>
            <span className="copy d-block">
              Tous droits réservés © 2020 | Réalisation 1000 MONDES
            </span>
          </div>
        </div>
      </footer>
    );
  }
}

export default HeaderNav;
